import * as HTTP from './http';

export const Order = async(order, payload) => {
    let endpoint = `logs/order`;

    const body = {
        order : order,
        payload : payload
    }

    try{
        var result = await HTTP.POST(endpoint, body);
    }catch(e){
        console.log(`CONTROLLER ERROR: logger.Order\n${e}`);
        return undefined;
    }

    return result;
}

export const Part = async(part, payload) => {
    let endpoint = `logs/part`;

    const body = {
        part : part,
        payload : payload
    }

    try{
        var result = await HTTP.POST(endpoint, body);
    }catch(e){
        console.log(`CONTROLLER ERROR: logger.Part\n${e}`);
        return undefined;
    }

    return result;
}